import { useEffect } from 'react';

const useEffectOnce = effect => {
  // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional mount-only effect wrapper
  useEffect(effect, []);
};

export default useEffectOnce;
